
import Swiper, {Navigation, Autoplay, Pagination} from 'swiper';

Swiper.use([Navigation, Autoplay, Pagination]);

const $heroSlider = $('.js-hero-slider');
const $partnersSlider = $('.js-partners-slider');
const $programsSlider = $('.js-programs-slider');
const $newsSlider = $('.js-news-slider');

let programsSlider = null;
let partnersSlider = null;
let parntersSliderMob = false;

const checkProgramsSlider = () => {
  if (window.matchMedia('(max-width: 767px)').matches) {
    if (programsSlider) return;
    programsSlider = new Swiper($programsSlider[0], {
      init: false,
      touchReleaseOnEdges: true,
      slidesPerView: 'auto',
      pagination: {
        el: $programsSlider.find('.js-programs-dots')[0],
        clickable: true
      }
    });
    programsSlider.init();
  } else {
    if (!programsSlider) return;
    programsSlider.destroy();
    programsSlider = null;
  }
};

const initPartnersSlider = config => {
  const mobConfig = {
    init: false,
    slidesPerView: 'auto',
    touchReleaseOnEdges: true,
    pagination: {
      el: $partnersSlider.find('.js-partners-dots')[0],
      clickable: true
    }
  };

  const deskConfig = {
    init: false,
    slidesPerView: 6,
    touchReleaseOnEdges: true,
    loop: true,
    navigation: {
      nextEl:  $partnersSlider.find('.js-partners-next')[0],
      prevEl: $partnersSlider.find('.js-partners-prev')[0]
    },
    pagination: {
      el: $partnersSlider.find('.js-partners-dots')[0],
      clickable: true
    }
  };

  const targetConfig = config === 'mob' ? mobConfig : deskConfig;

  partnersSlider = new Swiper($partnersSlider.find('.js-partners-slider-el')[0], targetConfig);
  partnersSlider.init();

}


const checkPartnersSlider = () => {
  if (window.matchMedia('(max-width: 767px)').matches) {
    if (partnersSlider) {
      if (parntersSliderMob) return;
      parntersSliderMob = true;
      partnersSlider.destroy();
      initPartnersSlider('mob');
    } else {
      initPartnersSlider('mob');
    }
  } else if (partnersSlider) {
      if (!parntersSliderMob) return;
      parntersSliderMob = false;
      partnersSlider.destroy();
      initPartnersSlider();
    } else {
      initPartnersSlider();
    }
};


const sliders = () => {
  if ($heroSlider.length) {
    const heroSlider = new Swiper($heroSlider[0], {
      init: false,
      loop: true,
      speed: 1000,
      noSwiping: false,
      noSwipingClass: 'swiper-slide',
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      navigation: {
        nextEl:  $heroSlider.find('.js-hero-next')[0],
        prevEl: $heroSlider.find('.js-hero-prev')[0]
      },
      breakpoints: {
        768: {
          noSwiping: true
        }
      }
    });

    heroSlider.init();
  }


  if ($newsSlider.length) {

    const $dots = $newsSlider.find('.js-news-slider-dots');

    const opts = {
      slidesPerView: 'auto',
      touchReleaseOnEdges: true,
      init: false
    };

    if ($dots.length) {
      opts.pagination = {
        el: $dots[0],
        clickable: true
      }
    }

    const newsSlider = new Swiper($newsSlider[0], opts);


    newsSlider.init();

  }

  if ($partnersSlider.length) {
    checkPartnersSlider();
    $(window).on('resize', checkPartnersSlider);
  }

  if ($programsSlider.length) {
    checkProgramsSlider();
    $(window).on('resize', checkProgramsSlider);
  }
};

export default sliders;
